import { render, staticRenderFns } from "./ViFeeSummaryDetails.vue?vue&type=template&id=f8810782&scoped=true"
import script from "./ViFeeSummaryDetails.vue?vue&type=script&lang=js"
export * from "./ViFeeSummaryDetails.vue?vue&type=script&lang=js"
import style0 from "./ViFeeSummaryDetails.vue?vue&type=style&index=0&id=f8810782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8810782",
  null
  
)

export default component.exports